export const ITEMS_API_URL = "https://pixiespace.ie/api/items/";
export const ATTENDEES_API_URL = "https://pixiespace.ie/api/attendees/";
export const LOCATIONS_API_URL = "https://pixiespace.ie/api/locations/";

// export const ITEMS_API_URL = "https://d1125yjrl6c5i2.cloudfront.net/api/items/";
// export const ATTENDEES_API_URL = "https://d1125yjrl6c5i2.cloudfront.net/api/attendees/";
// export const LOCATIONS_API_URL = "http://d1125yjrl6c5i2.cloudfront.net/api/locations/";
